import SeedInput from './SeedInput'

export default SeedInput
